import Types from "@camtv/front-base-lib/utilities/types";

export default class MediaDomainURL {

	static get SupportImageResize() {

			return [
				"serviceslocalcam.3technology.it",
				"servicesfullcam.3technology.it",
				"servicestestcam.3technology.it",

				"media0.cam.tv",
				"media0.testcam.tv",
				"media0.fullcam.tv",
				"media0.devcam.tv",

				"media.cam.tv",
				"media.testcam.tv",
				"media.fullcam.tv",
				"media.devcam.tv",

				"media1.cam.tv",
				"media1.testcam.tv",
				"media1.fullcam.tv",
				"media1.devcam.tv",

				"storage1.testcam.tv",
				"storage1.cam.tv",
				"storage1.devcam.tv",
				"storage1.fullcam.tv",

				"cloud1.cam.tv",
				"cloud1.fullcam.tv",
				"cloud1.testcam.tv",
				"cloud1.fullcam.tv"
			]
	};

	static get SupportMediaPass() {

		return [
			"camtv.ams3.digitaloceanspaces.com",

			"serviceslocalcam.3technology.it",

			"s3staticassets.cam.tv",

			"webinarmaster.cam.tv",
			"vodserver1.cam.tv",

			"media.localcam.tv",
			"media.devcam.tv",
			"media.fullcam.tv",
			"media.testcam.tv",
			"media.cam.tv",

			"media0.localcam.tv",
			"media0.devcam.tv",
			"media0.fullcam.tv",
			"media0.testcam.tv",
			"media0.cam.tv",

			"media1.localcam.tv",
			"media1.devcam.tv",
			"media1.fullcam.tv",
			"media1.testcam.tv",
			"media1.cam.tv",

			"cdnstatic.localcam.tv",
			"cdnstatic.devcam.tv",
			"cdnstatic.fullcam.tv",
			"cdnstatic.testcam.tv",
			"cdnstatic.cam.tv",

			"vodcdn.localcam.tv",
			"vodcdn.devcam.tv",
			"vodcdn.fullcam.tv",
			"vodcdn.testcam.tv",
			"vodcdn.cam.tv",

			"livecdn.localcam.tv",
			"livecdn.devcam.tv",
			"livecdn.fullcam.tv",
			"livecdn.testcam.tv",
			"livecdn.cam.tv",

			"cloud1.testcam.tv",
			"cloud1.cam.tv",

			"storage1.testcam.tv",
			"storage1.cam.tv",

			"www.youtube.com",
			"img.youtube.com",
		]
	};

	/**
	 * Method to resize an image via server
	 * @method
	 * @param {String} url - The url of the image
	 * @param {Number} size - The desired size of the resulting image
	 */
	static GetResizedImageURL(sUrl, size){
		try {
			if (sUrl.startsWith("data:image") == true)
				return url;

			if (sUrl.startsWith("blob:") == true)
				return sUrl;

			let DOMAIN_NAME_WITH_PROTOCOL = "https://"+document.location.hostname;
			if (sUrl.startsWith("/"))
				sUrl = DOMAIN_NAME_WITH_PROTOCOL + sUrl;

			let url = new URL(sUrl)

			let id = MediaDomainURL.SupportImageResize.indexOf(url.hostname);
			if (id >= 0 || url.hostname == DOMAIN_NAME_WITH_PROTOCOL) {
				let newUrl = sUrl.split("/");
				let lastElement = newUrl.pop();
				size = Types.ToInt(Math.round(size));
				sUrl = newUrl.join("/")+"/w"+size+"/"+lastElement;
			}
		}
		catch(Ex) {

		}

		return sUrl;
	}

	static GetCanvasEditableMediaURL(MediaSrc) {

		try {
			if (MediaSrc.startsWith("data:image") == true)
				return MediaSrc;

			if (MediaSrc.startsWith("blob:") == true)
				return MediaSrc;

			let DOMAIN_NAME_WITH_PROTOCOL = "https://"+document.location.hostname;
			if (MediaSrc.startsWith("/"))
				MediaSrc = DOMAIN_NAME_WITH_PROTOCOL + MediaSrc;

			let url = new URL(MediaSrc)

			if (DOMAIN_NAME_WITH_PROTOCOL.indexOf(url.hostname) >= 0)
				return MediaSrc;

			let id = MediaDomainURL.SupportMediaPass.indexOf(url.hostname);
			if (id < 0)
				throw "Domain not supports mediapass :"+url.hostname;

			return DOMAIN_NAME_WITH_PROTOCOL + "/mediapass?mediaurl=" + MediaSrc.replace("https://", "").replace("http://", "");
		}
		catch(Ex) {

		}

		return null;
	}

}

